import { Elements } from "@stripe/react-stripe-js";
import { StripeElementsOptions, Stripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import noImage from "../../../assests/tipperUiSection/toptipper-logo.png";
import StripePayment from "../../../components/stripePayment";
import TipperLayout from "../../../components/tipperUiSectionLayout";
import { AppDispatch, RootState } from "../../../store/store";
import styles from "./orderDelievered.module.scss";
import PaymentHeader from "../../../components/tippingUiSection/header";
import { setPrevUrl } from "../../../store/slices/paymentSlices";
import PaymentFooter from "../../../components/tippingUiSection/footer";
import { getStripe, resetStripeLoader } from "../../../utils/functions";

const OrderDelievered = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [isStripeLoading, setIsStripeLoading] = useState(false);
  // undefined = still loading, null = failed to load (blocker/timeout/network),
  // Stripe = ready.
  const [stripe, setStripe] = useState<Stripe | null | undefined>(undefined);
  const { data } = useSelector(
    (store: RootState) => store.paymentSlices.postTipAmount
  );
  const { media, name, org_name, type, property_name, fee_paid_by } = useSelector(
    (store: RootState) => store.paymentSlices.data
  );

  const { homeUrl, prevUrl } = useSelector(
    (store: RootState) => store.paymentSlices
  );
  const options: StripeElementsOptions = {
    // passing the client secret obtained from the server
    clientSecret: data?.clientSecret || "",
    appearance: {
      theme: "stripe",
      variables: {
        colorDanger: "#d22b2b",
        fontSizeSm: "12px",
        fontWeightMedium: "500",
      },
      rules: {

        ".Error": {
          color: "#d22b2b",
          fontWeight: "500",
          fontSize: "12px",
          textAlign: "end !important",
          width: "100%",
        },

        ".Label": {
          fontWeight: "700",
          color: "#6A6D7C",

          fontSize: "12px",
        },
        ".Input::placeholder": {
          color: "#A9B0BF",
        },

        ".Input--invalid": {
          boxShadow: "none",
          borderColor: "#e6e6e6",
        },
        ".Input--invalid:focus": {
          boxShadow: "none",
          borderColor: "#e6e6e6",
        },
      },
    },
  };
  useEffect(() => {
    setIsStripeLoading(true);
    setTimeout(() => {
      setIsStripeLoading(false);
    }, 2000);
  }, []);

  // Load Stripe.js safely: resolves to a Stripe instance, or null when the
  // script is blocked / times out / fails to load. Never throws, never leaves
  // <Elements> hanging.
  useEffect(() => {
    let mounted = true;
    getStripe().then((instance) => {
      if (mounted) {
        setStripe(instance);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  const handleRetryStripe = () => {
    setStripe(undefined);
    resetStripeLoader();
    // A full reload is the most reliable way to recover from a blocked or
    // aborted Stripe.js script (blocker toggled off, connection restored).
    window.location.reload();
  };
  // useEffect(() => {
  //   if (!data?.clientSecret) {
  //     window.location.href = `${process.env.REACT_APP_LANDING_URL}`;
  //   }
  // }, []);

  useEffect(() => {
    if (prevUrl === "/payment-completed") {
      navigate(`${homeUrl}`);
      dispatch(setPrevUrl(""));
    }
  }, []);


  useEffect(() => {
    if (!data?.clientSecret) {
      setTimeout(() => {
        if (location.key !== 'default') {
          // If there's a previous history, go back
          navigate(-1);
        } else {
          // Otherwise, navigate to the main page
          navigate('/');
        }
      }, 1000)

    }
  }, [data?.clientSecret, navigate, location]);


  return (
    data?.clientSecret ?
      <TipperLayout>
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 30,
          }}
        >
          <div className={styles.orderContainer}>
            <div className={styles.tipperContainer}>
              <div className={styles.tipperImg}>
                <div className={styles.tipperImg} style={{}}>
                  {false ? (
                    <Skeleton height={100} width={100} />
                  ) : (
                    <div
                      className={styles.circle}
                      style={{ backgroundColor: data?.theme_color }}
                    >
                      <img src={media ?? noImage} alt="" />
                    </div>
                  )}
                </div>
                <h5
                  className="mt-0"
                  style={{
                    color: "black",
                    fontWeight: 600,
                    wordBreak: "break-word",
                    paddingRight: "5px",
                  }}
                >
                  {org_name && type == "1"
                    ? org_name
                    : property_name
                      ? property_name
                      : ""}
                </h5>
              </div>
              <div className={styles.tipperBottom}>
                {false ? (
                  <Skeleton width={150} />
                ) : (
                  <>
                    {/* <h5 className="mt-0">
                    {type === "qr_organization_details" ||
                    type === "qr_property"
                      ? org_name
                      : property_name}
                  </h5> */}
                    {/* <p
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {name && name }{" "}
                  </p> */}
                  </>
                )}
                <div className={styles.suggestedAmount}>
                  {false ? (
                    <div
                      style={{
                        position: "relative",
                        backgroundColor: isStripeLoading ? "#EFEFEF" : "white",
                      }}
                    >
                      <Skeleton height={99} width={340} className="suggest" />
                      <div className={styles.skel}>
                        <Skeleton height={50} width={50} />
                        <Skeleton height={50} width={50} />
                        <Skeleton height={50} width={50} />
                      </div>
                    </div>
                  ) : (
                    <div className={styles.suggestCards}>
                      <div className={styles.chargeAmount}>
                        {" "}
                        {fee_paid_by == 1 ? <p>Tip Amount</p> : <p>Charged Amount</p>}
                        <span>
                          {(fee_paid_by == 1
                            ? Number(data?.tip_amount ?? 0)
                            : Number(data?.tip_amount ?? 0) +
                              Number(data?.application_fee ?? 0)
                          ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </span>
                      </div>
                      {fee_paid_by == 1 && <>
                        <div className={styles.chargeAmount}>
                          {" "}
                          <p>Application Fee</p>
                          <span>
                            {data?.application_fee?.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            }) ?? 0}
                          </span>
                        </div>
                        <div className={styles.chargeAmount}>
                          {" "}
                          <p>Charged Amount</p>
                          <span className={styles.end}>
                            {(
                              (data?.application_fee ?? 0) + (data?.tip_amount ?? 0)
                            )?.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </span>
                        </div>
                      </>}
                    </div>
                  )}
                </div>
                {data?.clientSecret && (
                  stripe ? (
                    <Elements stripe={stripe} options={options}>
                      {<StripePayment />}
                    </Elements>
                  ) : stripe === null ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "16px 8px",
                        color: "#676D7A",
                      }}
                    >
                      <p style={{ margin: "0 0 12px", fontSize: 14 }}>
                        We couldn't load the secure payment form. This can happen
                        if your connection dropped or a browser ad/privacy blocker
                        is blocking Stripe. Please check your connection or disable
                        the blocker for this page, then try again.
                      </p>
                      <button
                        type="button"
                        onClick={handleRetryStripe}
                        style={{
                          padding: "10px 20px",
                          border: "none",
                          borderRadius: 6,
                          background: "#1d4ed8",
                          color: "#ffffff",
                          fontSize: 14,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Try again
                      </button>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "16px 8px",
                      }}
                    >
                      <Skeleton height={40} width={320} />
                    </div>
                  )
                )}
              </div>
              <PaymentHeader />
            </div>
          </div>
          <PaymentFooter />
        </div>
      </TipperLayout> : null
  );
};
export default OrderDelievered;
